export const rescheduleModalTitle = 'Reschedule this service';
export const rescheduleModalDescription =
	'To avoid fees, if for any reason you need to reschedule or cancel your booking we ask that you contact us by 6:00 pm the night before with any changes. To make these changes, please contact us at contact@Pineapplelabs.io or +1 844.999.0877';
export const rescheduleModalButton = 'got it';
export const rescheduleButton = 'reschedule';
